import React from 'react';
import Sidebar from '../../Sidebar/Sidebar';
import Navbar from '../../Navbars/UserNavbar';
import { NavLink, Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface PlanOption {
  id: number;
  title: string;
  price: string;
  yearly: string;
  recommended?: boolean;
  numUsers: string;
  storage: string;
  photoVideoStorage: string;
  securityEnhance: string;
}

const UpgradeStorage: React.FC = () => {
  const navigate = useNavigate();
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const isLifetime = userLoginData?.data?.user_plan?.is_lifetime === true;
  const isAccountSuspended = userLoginData?.data?.user_plan?.status == 'suspended';

  if (isLifetime) {
    return <Navigate to="/dashboard" replace />;
  }

  const plans: PlanOption[] = [
    {
      id: 1,
      title: 'Basic',
      price: 'Free',
      yearly: 'Free',
      numUsers: '1 Recipient',
      storage: '100MB',
      photoVideoStorage: 'Unlimited',
      securityEnhance: 'None',
    },
    {
      id: 2,
      title: 'Gold',
      price: '$9.95 / month',
      yearly: '$100 / year (16% off)',
      recommended: true,
      numUsers: '100 Recipients',
      storage: '1TB',
      photoVideoStorage: 'Unlimited',
      securityEnhance: 'Security Enhance',
    },
    {
      id: 3,
      title: 'Platinum',
      price: '$19.95 / month',
      yearly: '$175 / year (45% off)',
      numUsers: '1000 Recipients',
      storage: '2TB',
      photoVideoStorage: 'Unlimited',
      securityEnhance: 'Security Enhance',
    },
  ];

  const handleSelectPlan = (planId: number) => {
    navigate(`/add-card?plan=${planId}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex flex-col md:flex-row">
        <Sidebar />
        <main className="flex-1 p-6 relative md:ml-64">
          <Navbar />

          {/* {isAccountSuspended && (
            <div className="mb-6 bg-red-50 border border-red-200 p-4 rounded-lg">
              <div className="flex items-start">
                <svg className="h-5 w-5 text-red-500 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <div>
                  <h3 className="text-red-800 font-medium">Account Suspended</h3>
                  <p className="text-red-700 text-sm">
                    Your account has been suspended due to an expired subscription. Please select a plan below to renew your subscription and regain access to all features.
                  </p>
                </div>
              </div>
            </div>
          )} */}

          <div className="min-h-screen bg-white">
            <div className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold text-center mb-8">
                {isAccountSuspended ? "Renew Your Subscription" : "Find the right bEternal package plan for you"}
              </h1>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                {plans.map((plan, index) => (
                  <div
                    key={index}
                    className={`bg-white shadow-lg rounded-lg p-6 ${plan.recommended ? 'border-4 border-green-500' : ''
                      }`}
                  >
                    <h2 className="text-xl font-bold mb-4">{plan.title}</h2>
                    <p className="text-2xl font-bold ">{plan.price}</p>
                    <p className="text-sm font-bold mb-4">{plan.yearly}</p>
                    {plan.recommended && (
                      <span className="bg-green-500 text-white px-4 py-2 rounded-full text-sm mb-4 inline-block">
                        Recommended
                      </span>
                    )}
                    <div className="space-y-2 leading-7">
                      <p className='flex justify-center '>
                        <span ><span className="font-bold"> Number of users:</span> <br /> <span className='flex justify-center'>{plan.numUsers}</span> </span>
                      </p>

                      <p className='flex justify-center pt-5'>
                        <span ><span className="font-bold"> Storage:</span> <br /> <span className='flex justify-center'>{plan.storage}</span> </span>
                      </p>
                    </div>

                    {plan.id === 1 ? (
                      <button
                        className="bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded-lg mt-6 w-full cursor-not-allowed"
                        disabled
                      >
                        Free Plan
                      </button>
                    ) : (
                      <button
                        onClick={() => handleSelectPlan(plan.id)}
                        className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-lg mt-6 w-full"
                      >
                        {isAccountSuspended ? 'Select Plan' : 'Get started'}
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default UpgradeStorage;